<template>
  <lateral-modal
    :title="$t(mileageCategoryModalHeader)"
    @close="closeModal"
  >
    <template slot="content">
      <form
        id="mileage-category-form"
        @submit.prevent="submit"
      >
        <div class="row">
          <div class="col-12">
            <div class="input--block input--block--margin">
              <label class="form--label u-required"> {{$t('company_create_mileage_category_name').toUpperCase()}}</label>
              <div
                class="Form-field"
                :class="{'Form--field-error': $v.mileageCategory.name.$error}"
              >
                <input
                  class="Input-text"
                  type="text"
                  v-model="mileageCategory.name"
                  @blur="$v.mileageCategory.name.$touch()"
                  :placeholder="$t('company_create_mileage_category_name')"
                >
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="input--block input--block--margin h-100">
              <label
                for=""
                class="form--label u-required"
              > {{$t('company_create_mileage_category_rate').toUpperCase()}}</label>
              <div class="Form-field">
                <currency-input
                  v-model="mileageCategory.rate"
                  class="Input-text"
                  currency="EUR"
                  locale="es"
                  :precision="3"
                  :allowNegative="false"
                  :placeholder="$t('company_create_mileage_category_rate')"
                ></currency-input>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div
        class="w-100 d-flex justify-content-center"
        v-if="isCallingExpenses"
      >
        <spinner />
      </div>
    </template>
    <template slot="footer">
      <button
        class="Fuell-Button blue block"
        :class="{'Fuell-Button--disabled' : !canBeSubmitted}"
        :disabled="!canBeSubmitted"
        type="submit"
        form="mileage-category-form"
      >
        <span class="Fuell-Button--label">
          {{$t(mileageCategoryConfirmButtonLabel)}}
        </span>
      </button>
    </template>
  </lateral-modal>
</template>

<script>
import { CurrencyInput } from 'vue-currency-input'
import Spinner from '@/components/Commons/Spinner'

import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import LateralModal from '@/components/Commons/Modals/LateralModal'
const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')
export default {
  name: 'CreateMileageCategoryModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: {
    CurrencyInput,
    Spinner,
    LateralModal
  },
  props: {
    mileageCategoryId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      mileageCategory: {
        name: '',
        rate: null
      },
      originalMileageCategory: {}

    }
  },
  computed: {
    originalMileageCategoryToEdit () {
      return this.mileageCategoryId && this.mileageCategoryId > 0 ? this.$store.getters['CompanyStore/ExpensesSettingsStore/mileageCategories'].find(el => el.id === this.mileageCategoryId) : false
    },
    canBeSubmitted () {
      return !this.$v.$invalid
    },
    mileageCategoryModalHeader () {
      return this.mileageCategoryId ? 'company_edit_mileage_category_modal_header' : 'company_create_mileage_category_modal_header'
    },
    mileageCategoryConfirmButtonLabel () {
      return this.mileageCategoryId ? 'company_edit_mileage_category_modal_confirm' : 'company_create_mileage_category_modal_confirm'
    },
    isCallingExpenses () {
      return this.$store.getters['CompanyStore/ExpensesSettingsStore/isCallingExpenses']
    }
  },
  methods: {
    async submit () {
      if (!this.canBeSubmitted) return
      if (!this.mileageCategoryId) {
        await this.$store.dispatch('CompanyStore/ExpensesSettingsStore/createMileageCategory', this.mileageCategory)
      } else {
        await this.$store.dispatch('CompanyStore/ExpensesSettingsStore/updateMileageCategory', this.mileageCategory)
      }
      this.closeModal()
    },
    _initialize () {
      if (this.mileageCategoryId) {
        this.originalMileageCategory = { ...this.mileageCategoryToEdit }
        Object.keys(this.originalMileageCategoryToEdit).forEach(key => {
          if (this.originalMileageCategoryToEdit[key]) {
            this.mileageCategory[key] = this.originalMileageCategoryToEdit[key]
          }
        })
        this.$v.$touch()
      }
    }

  },
  watch: {
    mileageCategoryId: function (newV, oldV) {
      if (newV > 0) {
        this._initialize()
      }
    }
  },
  validations: {
    mileageCategory: {
      name: { required },
      rate: { required }
    }
  },
  async created () {
    if (this.mileageCategoryId) {
      this._initialize()
    }
  },

  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  }

}
</script>

<style scoped>
.multiselect--error {
  border: 2px solid red;
  border-radius: 6px;
}

.include-in-all--explanation {
  margin-left: 2rem;
  color: var(--gray);
}
.Input-textarea {
  max-height: 113px;
}
.input--toggle-block {
  margin-top: 5px;
}
</style>
